var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandingProductBgLeftEffect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 551,
    height: 171,
    viewBox: "0 0 551 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M534.55 53.5516H327.04L326.92 53.418L307.47 31.7578H111.7L111.58 31.6241L84.8599 1.86777H23.9399L10.0298 17.3585L9.44995 16.7125L23.5999 0.95459H85.2L85.3198 1.08823L112.04 30.8446H307.81L307.93 30.9782L327.38 52.6385H534.55V53.5516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.62988 170.806H1.80981V36.2012L1.92993 36.0675L25.0298 10.3425L25.5999 10.9884L2.62988 36.5798V170.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.96 40.8005L316.71 52.7833H126.81L113.31 37.738H303.85L305.96 40.8005Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.24 27.2588H303.95L307.61 31.3347L111.87 31.3013L108.24 27.2588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.83 155.282H550.01V63.1178L534.27 45.578L534.84 44.9321L550.83 62.7392V155.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.55 59.7324V151.474V155.282L550.3 158.345L550.42 62.9286L547.55 59.7324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.38 42.7941H329.59L329.48 42.6605L307.44 18.127H288.24V17.2139H307.78L307.9 17.3475L329.93 41.8809H442.38V42.7941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.39 34.1187H455.64L463.02 42.3373H329.77L322.39 34.1187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.79 17.6703C285.79 15.8996 287.08 14.4519 288.68 14.4519C290.27 14.4519 291.57 15.8885 291.57 17.6703C291.57 19.441 290.28 20.8887 288.68 20.8887C287.09 20.8887 285.79 19.441 285.79 17.6703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.39 47.4935C534.986 47.4935 536.28 46.0525 536.28 44.275C536.28 42.4976 534.986 41.0566 533.39 41.0566C531.794 41.0566 530.5 42.4976 530.5 44.275C530.5 46.0525 531.794 47.4935 533.39 47.4935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3098 14.4964C26.9059 14.4964 28.2 13.0555 28.2 11.278C28.2 9.5005 26.9059 8.05957 25.3098 8.05957C23.7137 8.05957 22.4199 9.5005 22.4199 11.278C22.4199 13.0555 23.7137 14.4964 25.3098 14.4964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84985 17.7147C6.84985 15.9441 8.13999 14.4963 9.73999 14.4963C11.34 14.4963 12.6299 15.9329 12.6299 17.7147C12.6299 19.4854 11.34 20.9332 9.73999 20.9332C8.13999 20.9332 6.84985 19.4854 6.84985 17.7147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.55 47.0366H505.24V47.9498H523.55V47.0366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44995 36.1121H0.72998V45.3998H3.44995V36.1121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48994 30.5151L7.56665 28.3733L0.651214 36.0746L2.57451 38.2164L9.48994 30.5151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0898 1.86792L110.18 20.9H136.93L120.17 2.22428L93.0898 1.86792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.37 1.86792L146.45 20.9H173.21L156.44 2.22428L129.37 1.86792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.64 1.86792L182.73 20.9H209.48L192.71 2.22428L165.64 1.86792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.91 1.86792L219 20.9H245.75L228.98 2.22428L201.91 1.86792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.18 1.86792L255.27 20.9H282.02L265.26 2.22428L238.18 1.86792Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingProductBgLeftEffect);
export default __webpack_public_path__ + "static/media/landingProductBGLeftEffect.f7cb721983a60f980316d52f611f00a8.svg";
export { ForwardRef as ReactComponent };